// Session id minting (M6-D): `s-<32 lowercase hex>` = 128 bits of CSPRNG
// entropy. The import flow relies on this strength: a stash bound to a
// freshly minted id cannot collide with a pre-existing session, so a
// created:false answer to its createSession is provably the idempotent hit
// of this page's own (ACK-lost) create.
export function mintSessionId(getBytes: (count: number) => Uint8Array): string {
  const bytes = getBytes(16);
  if (bytes.length !== 16) throw new Error("session id minting requires 16 random bytes");
  let hex = "";
  for (const b of bytes) hex += b.toString(16).padStart(2, "0");
  return `s-${hex}`;
}
